// Generated by pnpm --filter @langfuse/icons generate. Do not edit.
import { createIcon } from "../../create-icon.js";
import { CreditCard as RawCreditCard } from "lucide-react";
export const CreditCard = /* @__PURE__ */ createIcon(RawCreditCard, "CreditCard", 2);
